import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Lock, Camera, Save, Package, Heart, LogOut, Edit2, Plus, Trash2 } from 'lucide-react';
import Header from './components/Header21';
import Footer from './components/Footer21';

import { devLog } from '../../../utils/devLog';

const Profile21 = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Ananya Sharma',
        email: 'ananya.sharma@example.com',
        phone: '+91 98765 43210',
        avatar: 'https://ui-avatars.com/api/?name=Ananya+Sharma&size=200&background=C9A96E&color=0A0A0A&font-size=0.4',
        address: {
            street: '45 Heritage Lane',
            city: 'Mumbai',
            state: 'Maharashtra',
            pincode: '400001',
        },
        bio: 'Connoisseur of fine Indian couture and handcrafted textiles.',
    });

    const [addresses, setAddresses] = useState([
        {
            id: 1,
            label: 'Home',
            name: 'Ananya Sharma',
            street: '45 Heritage Lane, Bandra West',
            city: 'Mumbai',
            state: 'Maharashtra',
            pincode: '400050',
            phone: '+91 98765 43210',
            isDefault: true,
        },
        {
            id: 2,
            label: 'Office',
            name: 'Ananya Sharma',
            street: '12 Business Park, Lower Parel',
            city: 'Mumbai',
            state: 'Maharashtra',
            pincode: '400013',
            phone: '+91 98765 43210',
            isDefault: false,
        },
    ]);

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setProfileData({
                ...profileData,
                [parent]: {
                    ...profileData[parent],
                    [child]: value,
                },
            });
        } else {
            setProfileData({ ...profileData, [name]: value });
        }
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    const handleSaveProfile = (e) => {
        e.preventDefault();
        devLog.log('Profile updated:', profileData);
        setIsEditing(false);
    };

    const handleChangePassword = (e) => {
        e.preventDefault();
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            alert('Passwords do not match!');
            return;
        }
        devLog.log('Password changed');
        setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    };

    const handleLogout = () => {
        navigate('/template21/login');
    };

    const handleDeleteAddress = (id) => {
        setAddresses(addresses.filter(addr => addr.id !== id));
    };

    const tabs = [
        { id: 'profile', label: 'Profile', icon: User },
        { id: 'orders', label: 'Orders', icon: Package },
        { id: 'wishlist', label: 'Wishlist', icon: Heart },
        { id: 'security', label: 'Security', icon: Lock },
    ];

    const inputClasses = "w-full px-4 py-3 bg-[#1A1A1A] border border-[#2A2A2A] rounded-lg text-[#F5F0EB] placeholder-[#8A8A7A] focus:outline-none focus:border-[#C9A96E] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500&family=DM+Sans:wght@300;400;500;600;700&display=swap');
            `}</style>
            <div style={{ fontFamily: "'DM Sans', -apple-system, sans-serif" }} className="min-h-screen bg-[#0A0A0A]">
                <Header />

                <div className="container mx-auto px-4 lg:px-8 py-8 lg:py-12">
                    <h1 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }} className="text-3xl lg:text-4xl font-light text-[#F5F0EB] mb-8">
                        My Account
                    </h1>

                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                        {/* Sidebar */}
                        <div className="lg:col-span-1">
                            <div className="border border-[#2A2A2A] rounded-lg p-6 bg-[#141414]">
                                {/* Profile Picture */}
                                <div className="text-center mb-6">
                                    <div className="relative inline-block">
                                        <img
                                            src={profileData.avatar}
                                            alt={profileData.fullName}
                                            className="w-24 h-24 rounded-full mx-auto mb-4 border-2 border-[#C9A96E]"
                                        />
                                        <button className="absolute bottom-4 right-0 p-2 bg-[#C9A96E] rounded-full hover:bg-[#D4B87A] transition-colors">
                                            <Camera size={14} className="text-[#0A0A0A]" />
                                        </button>
                                    </div>
                                    <h3 className="font-medium text-[#F5F0EB]">{profileData.fullName}</h3>
                                    <p className="text-sm text-[#8A8A7A]">{profileData.email}</p>
                                </div>

                                {/* Navigation Tabs */}
                                <div className="space-y-2">
                                    {tabs.map(tab => {
                                        const Icon = tab.icon;
                                        return (
                                            <button
                                                key={tab.id}
                                                onClick={() => setActiveTab(tab.id)}
                                                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                                                    activeTab === tab.id
                                                        ? 'bg-[#C9A96E] text-[#0A0A0A]'
                                                        : 'text-[#8A8A7A] hover:bg-[#1A1A1A] hover:text-[#F5F0EB]'
                                                }`}
                                            >
                                                <Icon size={20} />
                                                <span className="font-medium">{tab.label}</span>
                                            </button>
                                        );
                                    })}
                                    <button
                                        onClick={handleLogout}
                                        className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-400 hover:bg-red-400/10 transition-all"
                                    >
                                        <LogOut size={20} />
                                        <span className="font-medium">Logout</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="lg:col-span-3">
                            {/* Profile Tab */}
                            {activeTab === 'profile' && (
                                <div className="space-y-8">
                                    <div className="border border-[#2A2A2A] rounded-lg p-6 lg:p-8 bg-[#141414]">
                                        <div className="flex justify-between items-center mb-6">
                                            <h2 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }} className="text-2xl font-light text-[#F5F0EB]">Profile Information</h2>
                                            <button
                                                onClick={() => setIsEditing(!isEditing)}
                                                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                                                    isEditing
                                                        ? 'bg-[#1A1A1A] text-[#8A8A7A] border border-[#2A2A2A]'
                                                        : 'bg-[#C9A96E] text-[#0A0A0A] hover:bg-[#D4B87A]'
                                                }`}
                                            >
                                                <Edit2 size={16} />
                                                {isEditing ? 'Cancel' : 'Edit'}
                                            </button>
                                        </div>

                                        <form onSubmit={handleSaveProfile}>
                                            <div className="space-y-6">
                                                {/* Personal Information */}
                                                <div>
                                                    <h3 className="font-medium text-[#C9A96E] text-sm tracking-wide uppercase mb-4">Personal Details</h3>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-[#F5F0EB] mb-2">Full Name</label>
                                                            <input
                                                                type="text"
                                                                name="fullName"
                                                                value={profileData.fullName}
                                                                onChange={handleInputChange}
                                                                disabled={!isEditing}
                                                                className={inputClasses}
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-[#F5F0EB] mb-2">Email</label>
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                value={profileData.email}
                                                                onChange={handleInputChange}
                                                                disabled={!isEditing}
                                                                className={inputClasses}
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-[#F5F0EB] mb-2">Phone</label>
                                                            <input
                                                                type="tel"
                                                                name="phone"
                                                                value={profileData.phone}
                                                                onChange={handleInputChange}
                                                                disabled={!isEditing}
                                                                className={inputClasses}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bio */}
                                                <div>
                                                    <label className="block text-sm font-medium text-[#F5F0EB] mb-2">Bio</label>
                                                    <textarea
                                                        name="bio"
                                                        value={profileData.bio}
                                                        onChange={handleInputChange}
                                                        disabled={!isEditing}
                                                        rows="3"
                                                        className={`${inputClasses} resize-none`}
                                                    />
                                                </div>

                                                {/* Address */}
                                                <div>
                                                    <h3 className="font-medium text-[#C9A96E] text-sm tracking-wide uppercase mb-4">Default Address</h3>
                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-[#F5F0EB] mb-2">Street Address</label>
                                                            <input
                                                                type="text"
                                                                name="address.street"
                                                                value={profileData.address.street}
                                                                onChange={handleInputChange}
                                                                disabled={!isEditing}
                                                                className={inputClasses}
                                                            />
                                                        </div>
                                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                            <div>
                                                                <label className="block text-sm font-medium text-[#F5F0EB] mb-2">City</label>
                                                                <input
                                                                    type="text"
                                                                    name="address.city"
                                                                    value={profileData.address.city}
                                                                    onChange={handleInputChange}
                                                                    disabled={!isEditing}
                                                                    className={inputClasses}
                                                                />
                                                            </div>
                                                            <div>
                                                                <label className="block text-sm font-medium text-[#F5F0EB] mb-2">State</label>
                                                                <input
                                                                    type="text"
                                                                    name="address.state"
                                                                    value={profileData.address.state}
                                                                    onChange={handleInputChange}
                                                                    disabled={!isEditing}
                                                                    className={inputClasses}
                                                                />
                                                            </div>
                                                            <div>
                                                                <label className="block text-sm font-medium text-[#F5F0EB] mb-2">PIN Code</label>
                                                                <input
                                                                    type="text"
                                                                    name="address.pincode"
                                                                    value={profileData.address.pincode}
                                                                    onChange={handleInputChange}
                                                                    disabled={!isEditing}
                                                                    className={inputClasses}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {isEditing && (
                                                    <button
                                                        type="submit"
                                                        className="flex items-center gap-2 px-8 py-3 bg-[#C9A96E] text-[#0A0A0A] font-semibold rounded-lg hover:bg-[#D4B87A] transition-colors"
                                                    >
                                                        <Save size={20} />
                                                        Save Changes
                                                    </button>
                                                )}
                                            </div>
                                        </form>
                                    </div>

                                    {/* Saved Addresses */}
                                    <div className="border border-[#2A2A2A] rounded-lg p-6 lg:p-8 bg-[#141414]">
                                        <div className="flex justify-between items-center mb-6">
                                            <h2 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }} className="text-2xl font-light text-[#F5F0EB]">Saved Addresses</h2>
                                            <button className="flex items-center gap-2 px-4 py-2 border border-[#C9A96E] text-[#C9A96E] rounded-lg text-sm font-medium hover:bg-[#C9A96E] hover:text-[#0A0A0A] transition-colors">
                                                <Plus size={16} />
                                                Add New Address
                                            </button>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            {addresses.map((addr) => (
                                                <div key={addr.id} className="border border-[#2A2A2A] rounded-lg p-5 bg-[#1A1A1A] relative">
                                                    {addr.isDefault && (
                                                        <span className="absolute top-3 right-3 text-xs bg-[#C9A96E] text-[#0A0A0A] px-2 py-1 rounded font-medium">Default</span>
                                                    )}
                                                    <h4 className="font-medium text-[#F5F0EB] mb-1">{addr.label}</h4>
                                                    <p className="text-[#8A8A7A] text-sm mb-1">{addr.name}</p>
                                                    <p className="text-[#8A8A7A] text-sm">{addr.street}</p>
                                                    <p className="text-[#8A8A7A] text-sm">{addr.city}, {addr.state} - {addr.pincode}</p>
                                                    <p className="text-[#8A8A7A] text-sm mt-1">{addr.phone}</p>
                                                    <div className="flex gap-3 mt-4">
                                                        <button className="text-[#C9A96E] text-sm hover:text-[#D4B87A] transition-colors">Edit</button>
                                                        <button
                                                            onClick={() => handleDeleteAddress(addr.id)}
                                                            className="text-red-400 text-sm hover:text-red-300 transition-colors flex items-center gap-1"
                                                        >
                                                            <Trash2 size={14} />
                                                            Remove
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Orders Tab */}
                            {activeTab === 'orders' && (
                                <div className="border border-[#2A2A2A] rounded-lg p-6 lg:p-8 bg-[#141414]">
                                    <h2 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }} className="text-2xl font-light text-[#F5F0EB] mb-6">Recent Orders</h2>
                                    <div className="text-center py-12">
                                        <Package size={64} className="text-[#2A2A2A] mx-auto mb-4" />
                                        <p className="text-[#8A8A7A] mb-6">View all your orders in one place</p>
                                        <button
                                            onClick={() => navigate('/template21/orders')}
                                            className="px-8 py-3 bg-[#C9A96E] text-[#0A0A0A] font-semibold rounded-lg hover:bg-[#D4B87A] transition-colors"
                                        >
                                            View All Orders
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Wishlist Tab */}
                            {activeTab === 'wishlist' && (
                                <div className="border border-[#2A2A2A] rounded-lg p-6 lg:p-8 bg-[#141414]">
                                    <h2 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }} className="text-2xl font-light text-[#F5F0EB] mb-6">My Wishlist</h2>
                                    <div className="text-center py-12">
                                        <Heart size={64} className="text-[#2A2A2A] mx-auto mb-4" />
                                        <p className="text-[#8A8A7A] mb-6">Your wishlist is empty</p>
                                        <button
                                            onClick={() => navigate('/template21/shop')}
                                            className="px-8 py-3 bg-[#C9A96E] text-[#0A0A0A] font-semibold rounded-lg hover:bg-[#D4B87A] transition-colors"
                                        >
                                            Explore Collections
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Security Tab */}
                            {activeTab === 'security' && (
                                <div className="border border-[#2A2A2A] rounded-lg p-6 lg:p-8 bg-[#141414]">
                                    <h2 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }} className="text-2xl font-light text-[#F5F0EB] mb-6">Security Settings</h2>
                                    <form onSubmit={handleChangePassword}>
                                        <div className="space-y-6">
                                            <div>
                                                <h3 className="font-medium text-[#C9A96E] text-sm tracking-wide uppercase mb-4">Change Password</h3>
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className="block text-sm font-medium text-[#F5F0EB] mb-2">Current Password</label>
                                                        <input
                                                            type="password"
                                                            name="currentPassword"
                                                            value={passwordData.currentPassword}
                                                            onChange={handlePasswordChange}
                                                            className={inputClasses}
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-[#F5F0EB] mb-2">New Password</label>
                                                        <input
                                                            type="password"
                                                            name="newPassword"
                                                            value={passwordData.newPassword}
                                                            onChange={handlePasswordChange}
                                                            minLength="8"
                                                            className={inputClasses}
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-[#F5F0EB] mb-2">Confirm New Password</label>
                                                        <input
                                                            type="password"
                                                            name="confirmPassword"
                                                            value={passwordData.confirmPassword}
                                                            onChange={handlePasswordChange}
                                                            minLength="8"
                                                            className={inputClasses}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                type="submit"
                                                className="flex items-center gap-2 px-8 py-3 bg-[#C9A96E] text-[#0A0A0A] font-semibold rounded-lg hover:bg-[#D4B87A] transition-colors"
                                            >
                                                <Lock size={20} />
                                                Update Password
                                            </button>
                                        </div>
                                    </form>

                                    <div className="mt-8 pt-8 border-t border-[#2A2A2A]">
                                        <h3 className="font-medium text-[#C9A96E] text-sm tracking-wide uppercase mb-4">Two-Factor Authentication</h3>
                                        <p className="text-[#8A8A7A] mb-4">Add an extra layer of security to your account</p>
                                        <button className="px-6 py-2 border border-[#C9A96E] text-[#C9A96E] rounded-lg text-sm font-medium hover:bg-[#C9A96E] hover:text-[#0A0A0A] transition-colors">
                                            Enable 2FA
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Profile21;
